import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface MobileFilterRowProps {
  label: string;
  value?: string;
  onClick: () => void;
  testId?: string;
}

// Collapsed state of a single filter inside the mobile filters drawer. Shared by
// Country/State/Week so the rows keep one height, one border and one chevron.
export const MobileFilterRow = ({ label, value, onClick, testId }: MobileFilterRowProps) => (
  <button
    type='button'
    className='flex min-h-[56px] w-full items-center justify-between gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3 text-left'
    onClick={onClick}
    data-testid={testId}
  >
    <span className='text-base text-gray-900'>{label}</span>
    <span className='flex items-center gap-2 text-sm text-gray-600'>
      {value}
      <FontAwesomeIcon icon={faChevronRight} className='text-xs text-gray-400' />
    </span>
  </button>
);
